import {
  receivableStateOptions,
  customerTypeOptions,
  overDueLevelOptions,
  followStateOptions,
  leaseStatusOptions,
  leaseStatusKey,
} from './constants'
import { operateMaxShowLength } from '@/store/dict/config'

const validateNumber = (rule, value, callback) => {
  if (value && !/^\d+$/.test(value)) {
    callback(new Error('应收id只能输入数字'))
    return
  }
  callback()
}

// 表单验证信息
const rules = {
  receivableId: [
    { validator: validateNumber, trigger: 'blur' },
  ],
}
/**
 * 逾期明细表
 */
const config = function () {
  return {
    columns: [
      {
        name: 'receivableId',
        columnProps: {
          label: '应收ID',
          prop: 'receivableId',
          width: '100',
        },
      },
      {
        name: 'customerName',
        columnProps: {
          label: '客户名称',
          prop: 'customerName',
          width: 110,
        },
      },
      {
        name: 'customerType',
        columnProps: {
          label: '客户来源',
          prop: 'customerType',
        },
        render: ({ row }) => {
          const findItem = customerTypeOptions.find((item) => item.value === row.customerType)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'idCardNo',
        columnProps: {
          label: '身份证号码',
          prop: 'idCardNo',
          width: '150px',
        },
      },
      {
        name: 'customerTel',
        columnProps: {
          label: '电话',
          prop: 'customerTel',
          width: '110px',
        },
      },
      {
        name: 'accruedCycle',
        columnProps: {
          label: '账单周期',
          prop: 'accruedCycle',
          width: '100px',
        },
      },
      {
        name: 'receivableAmount',
        columnProps: {
          label: '应交租金（当前）',
          prop: 'receivableAmount',
          width: '150px',
        },
        columnHeaderTooltip: '默认优先显示当前月份应交租金，通过日期筛选可查看对应应收日期的应交租金',
      },
      {
        name: 'receivedAmount',
        columnProps: {
          label: '实收租金（当前）',
          prop: 'receivedAmount',
          width: '150px',
        },
        columnHeaderTooltip: '默认优先显示当前月份实收租金，通过日期筛选可查看对应应收日期的实收租金',
      },
      {
        name: 'remainAmount',
        columnProps: {
          label: '剩余应收金额',
          prop: 'remainAmount',
          width: '110px',
        },
      },
      {
        name: 'brandName',
        columnProps: {
          label: '品牌',
          prop: 'brandName',
        },
      },
      {
        name: 'seriesName',
        columnProps: {
          label: '车系',
          prop: 'seriesName',
        },
      },
      {
        name: 'modelName',
        columnProps: {
          label: '车型',
          prop: 'modelName',
          width: '160px',
        },
      },
      {
        name: 'plateNo',
        columnProps: {
          label: '车牌号',
          prop: 'plateNo',
          width: '100px',
        },
      },
      {
        name: 'orderState',
        columnProps: {
          label: '租赁状态',
          prop: 'orderState',
          width: '100px',
        },
        getText: ({ row }) => {
          return leaseStatusKey[row.orderState] || '--'
        },
      },
      {
        name: 'overDueLevel',
        columnProps: {
          label: '逾期阶段',
          prop: 'overDueLevel',
        },
        render: ({ row }) => {
          const findItem = overDueLevelOptions.find((item) => item.value === row.overDueLevel)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'dueDate',
        columnProps: {
          label: '应收日期',
          prop: 'dueDate',
          width: '100px',
        },
      },
      {
        name: 'overDueDate',
        columnProps: {
          label: '逾期日期',
          prop: 'overDueDate',
          width: '100px',
        },
      },
      {
        name: 'overDueDay',
        columnProps: {
          label: '逾期天数',
          prop: 'overDueDay',
        },
      },
      {
        name: 'receivableState',
        columnProps: {
          label: '还款状态',
          prop: 'receivableState',
        },
        render: ({ row }) => {
          const findItem = receivableStateOptions.find((item) => item.value === row.receivableState)
          return this.$createElement('el-tag', {
            props: {
              type: findItem && findItem.type,
            },
          }, (findItem && findItem.label) || '--')
        },
        // 组件库提供的tag类型列，text默认取的是prop定义的属性值，并不能动态改变
        // tagProps: ({ row }) => {
        //   const findItem = receivableStateOptions.find(item => item.value === row.receivableState)
        //   return { type: findItem.type, text: findItem.label }
        // },
        // type: 'tag'
      },
      {
        name: 'followState',
        columnProps: {
          label: '跟进状态',
          prop: 'followState',
        },
        render: ({ row }) => {
          const findItem = followStateOptions.find((item) => item.value === row.followState)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'followNumber',
        columnProps: {
          label: '跟进次数',
          prop: 'followNumber',
        },
      },
      {
        name: 'operate',
        columnProps: {
          label: '操作',
          fixed: 'right',
          width: 240,
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const btns = []
          if (this.judgePermission('under_lease_over_due_hasten_debt_list_detail')) {
            btns.push({ name: 'overdueDetail', label: '详情', action: () => this.overdueDetailHandle(row) })
          }
          // 待跟进、跟进中 有 跟进 操作
          if (row.followState !== 2 && this.judgePermission('under_lease_over_due_hasten_debt_list_follow')) {
            btns.push({ name: 'follow', label: '跟进', action: () => this.followHandle(row) })
          }
          return btns
        },
        type: 'operate',
      },
    ],
    rules,
    receivableStateOptions,
    customerTypeOptions,
    overDueLevelOptions,
    leaseStatusOptions,
    followStateOptions,
  }
}

export default config
